import React, { useContext, useEffect, useState } from "react"
import styled from "styled-components"

import Footer from "../components/Footer"
import SimpleFormInput from "../components/SimpleFormInput"
import SimpleTextArea from "../components/SimpleTextArea"
import { addDoc, collection, doc,  updateDoc } from "firebase/firestore"
import { db, useAuth } from "../firebase-config"
import { toast, ToastContainer } from "react-toastify"
import ImageInputBtn from "../components/ImageInputBtn"
import { ProductDetailContext } from "../context/ProductDetailsProvider"
import { v4 as uuidv4 } from 'uuid';

const ProductScreen = () => {
  const currentUser = useAuth()
  const {data, docId} = useContext(ProductDetailContext)
  const [productDetails, setProductDetails] = useState({
    productName: "",
    currency: "",
    originalPrice:"",
    discountedPrice:"",
    category: "",
    subCategory: "",
    description:"",
    geoArea: "",
    platform: "",
    games: "",
  })

  const [productPhoto, setProductPhoto] = useState(
    Object.keys(data).length
      ? data?.productPhoto
      : "https://i1.wp.com/belmontbec.com/wp-content/themes/oldnevia2/images/shop-01.jpg"
  )
    
  const [addProductPrg, setAddProductPrg] = useState(
    Object.keys(data).length ? "Update" : "Save"
  )

  const generateKeywords = postName => {
    const wordArr = postName.toLowerCase().split(" ")

    const searchableKeywords = []

    let prevKey = ""

    for (const word of wordArr) {
      const charArr = word.toLowerCase().split("")

      for (const char of charArr) {
        const keyword = prevKey + char

        searchableKeywords.push(keyword)

        prevKey = keyword
      }

      prevKey = ""
    }

    return searchableKeywords
  }

  function encodeImageFileAsURL(element) {
    var file = element.target.files[0]
    var reader = new FileReader()
    reader.onloadend = function () {
      setProductPhoto(reader.result)
    }
    reader.readAsDataURL(file)
  }

  const addProduct = async () => {
    if (!productDetails.productName && !productDetails.category) {
      toast.warning("Please fill All details")
    } else {
      try {
        setAddProductPrg("Saving...")
        await addDoc(collection(db, "products"), {
          productDetails,
          productId: uuidv4(),
          productPhoto: productPhoto,
          sellerName: currentUser?.displayName,
          shopId: `shop/${currentUser.uid}`,
          searchableKeywords: generateKeywords(productDetails.productName),
        })
        setAddProductPrg("Saved")
        toast.success("Product Added")
        setProductDetails({
          productName: "",
          productUrl: "",
          originalPrice: "",
          discountedPrice: "",
          category: "",
          subCategory: "",
          description: "",
          // productId: "",
        })
      } catch (error) {
        setAddProductPrg("Save")
        console.log(error)
      }
    }
  }

  const updateProduct = async () => {
    if (!productDetails.productName && !productDetails.category) {
      toast.warning("Please fill All details")
    } else {
      try {
        setAddProductPrg("Updating...")
        await updateDoc(doc(db, "products", docId), {
          productDetails,
          productPhoto: productPhoto,
          productId: uuidv4(),
          searchableKeywords: generateKeywords(productDetails.productName),
        })
        setAddProductPrg("Updates")
        toast.success("Product Updated")
        setProductDetails({
          productName: "",
          productUrl: "",
          originalPrice: 0,
          discountedPrice: 0,
          category: "",
          subCategory: "",
          description: "",
        })
      } catch (error) {
        setAddProductPrg("Save")
        console.log(error)
      }
    }
  }

  const handleOnChange = (e) => {
    setProductDetails({...productDetails,[e.target.name]: e.target.value})
  }

  console.log(productDetails)

  useEffect(() => {
    if(data?.productDetails?.productName){
      setProductDetails(data.productDetails)
      }
  }, [data?.productDetails])
  

  return (
    <>
      <ToastContainer limit={1} position="top-center" />
      <ListWrapper>
        <ProductOption>
          <span className="productTitle">Products </span>
          <div className="addProductBtn">
            <button>
              <span>Add Product</span>
            </button>
          </div>
        </ProductOption>
        {
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ProductImage src={productPhoto} />
          </div>
        }
        <ImageInputBtn
          btnLabel={"Edit"}
          handleOnChange={encodeImageFileAsURL}
        />
        <div style={{display: 'flex', flexDirection: 'column', width: '95%'}} >
          <SimpleFormInput
            name="productName"
            placeholder={"Product Name"}
            value={productDetails.productName}
            handleOnChange={handleOnChange}
            label={"My first Product*"}
          />
           <SimpleFormInput
            name="currency"
            list={"currency"}
            placeholder={"Select Currency*"}
            handleOnChange={handleOnChange}
            value={productDetails.currency}
            label={"Currency*"}
          />
          <datalist id="currency">
            <option value="$"/>
            <option value="€"/>
          </datalist>
          <SimpleFormInput
            name="originalPrice"
            placeholder={"Original Price"}
            value={productDetails.originalPrice}
            handleOnChange={handleOnChange}
            label={"Original Price*"}
            type="number"
          />
          <SimpleFormInput
            name="discountedPrice"
            value={productDetails.discountedPrice}
            handleOnChange={handleOnChange}
            placeholder={"Discounted Price if Any"}
            label={"Discounted Price"}
            type="number"

          />
          <SimpleTextArea
            name="description"
            placeholder={"Description"}
            handleOnChange={handleOnChange}
            value={productDetails.description}
            label={"Description"}
          />
          <SimpleFormInput
            name="category"
            list={"category"}
            placeholder={"Select Category*"}
            handleOnChange={handleOnChange}
            value={productDetails.category}
            label={"Category*"}
          />

          <datalist id="category">
            <option value="Games" />
            <option value="Hardware" />
            <option value="Cosmetics" />
            <option value="Others" />
          </datalist>
          <SimpleFormInput
            name="subCategory"
            list={"subcategory"}
            placeholder={"Select Sub-Category from list*"}
            handleOnChange={handleOnChange}
            value={productDetails.subCategory}
            label={"Sub-Category"}
          />
          <datalist id="subcategory">
            {productDetails.category == "Games" ? (
              <>
                <option value="boardgames" />
                <option value="pcgames" />
                <option value="retrogaming" />
              </>
            ) : productDetails.category === "Hardware" ? (
              <>
                <option value="consoles" />
                <option value="retrogaming" />
                <option value="office" />
                <option value="consolegames" />
                <option value="professional" />
              </>
            ) : productDetails.category === "Cosmetics" ? (
              <>
                <option value="skins" />
                <option value="items" />
                <option value="others" />
              </>
            ) : <option value="others" />}
          </datalist>
          <SimpleFormInput 
            name="games"
            type="text"
            value={productDetails.games}
            handleOnChange={handleOnChange}
            label={"Games"} />
          <SimpleFormInput
            name="platform"
            type="text"
            value={productDetails.platform}
            handleOnChange={handleOnChange}
            label={"Platform"} />
          <SimpleFormInput
            name="geoArea"
            type="text"
            value={productDetails.geoArea}
            handleOnChange={handleOnChange}
            label={"Geographical Area"} />
        </div>
        <SaveBtn
          onClick={
            Object.keys(data).length ? updateProduct : addProduct
          }
          disabled={addProductPrg === "Saved" ? true : false}
          style={{
            opacity: addProductPrg === "Saved" && 0.4,
          }}
        >
          {addProductPrg}
        </SaveBtn>
      </ListWrapper>
      <Footer />
    </>
  )
}

export default ProductScreen
const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
`
const ProductOption = styled.div`
  display: flex;
  width: 82%;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
  .productTitle {
    font-size: 2rem;
    font-family: Montserrat;
    font-weight: 600;
    letter-spacing: 2px;
    color: ${({ theme }) => theme.accent};

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
  .addProductBtn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .addProductBtn button {
    background: none;
    border: none;
    color: ${({ theme }) => theme.text};
    font-size: 1.2rem;
    font-family: Montserrat;
    font-weight: 600;
    letter-spacing: 2px;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    justify-content: space-between;
  }
`
const ProductImage = styled.img`
  width: 80%;
  height: 30rem;
  object-fit: cover;
`
const ProductDetail = styled.form`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 1rem 0;
`
const SaveBtn = styled.button`
  cursor: pointer;
  background: var(--p-red);
  border: none;
  width: 10rem;
  color: #fff;
  float: right;
  height: 3rem;
  margin: 1rem 0;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
`
const ActionBtn = styled.div`
  /* position: absolute; */
  border: none;
  padding: 0.8rem 3rem;
  max-height: 5rem;
  max-width: 4rem;
  color: var(--white);
  font-size: 0.8rem;
  font-family: Montserrat;
  font-weight: 600;
  right: 2rem;
  bottom: 2rem;
  cursor: pointer;
  background: var(--black-shade);
`
